import React from "react";
import { Helmet } from "react-helmet";
import "../../../App.css";
import titleImage from "../../../assets/TitleItems.png";

import coin7500 from "../../../assets/items/7500xp.png";
import coin20000 from "../../../assets/items/20000xp.png";
import coin50000 from "../../../assets/items/50000xp.png";
import alienware from "../../../assets/items/alienware.png";
import amdDesktop from "../../../assets/items/amd_desktop.png";
import asusVivobook from "../../../assets/items/asus_vivobook.png";
import bodyGuard from "../../../assets/items/body_guard.png";
import c8Carbine from "../../../assets/items/c8_carbine_CLEAN.png";
import chromebook from "../../../assets/items/chromebook.png";
import cloak from "../../../assets/items/cloak.png";
import crowbar from "../../../assets/items/crowbar.png";
import crystalBall from "../../../assets/items/crystal_ball.png";
import dagger from "../../../assets/items/dagger.png";
import desertEagle from "../../../assets/items/desert_eagle.png";
import dirtyBomb from "../../../assets/items/dirty_bomb_CLEAN.png";
import drone from "../../../assets/items/drone.png";
import flipperZero from "../../../assets/items/flipper_zero.png";
import fullPass from "../../../assets/items/full_pass.png";
import goggles from "../../../assets/items/goggles.png";
import holyWater from "../../../assets/items/holy_water.png";
import horcrux from "../../../assets/items/horcrux.png";
import libremMini from "../../../assets/items/librem_mini.png";
import lv1Armour from "../../../assets/items/lv1_armour.png";
import lv2Armour from "../../../assets/items/lv2_armour.png";
import lv3Armour from "../../../assets/items/lv3_armour.png";
import lv4Armour from "../../../assets/items/lv4_armour.png";
import lv5Armour from "../../../assets/items/lv5_armour.png";
import offgridLaboratory from "../../../assets/items/offgrid_laboratory.png";
import rasberryPi from "../../../assets/items/rasberry_pi_CLEAN.png";
import reloader from "../../../assets/items/reloader.png";
import revolver from "../../../assets/items/revolver.png";
import samsungLaptop from "../../../assets/items/samsung_laptop.png";
import sawnOff from "../../../assets/items/sawn_off.png";
import secureWorkstation from "../../../assets/items/secure_workstation.png";
import stick from "../../../assets/items/stick.png";
import sword from "../../../assets/items/sword.png";
import titaniumShield from "../../../assets/items/titanium_shield.png";
import uzi from "../../../assets/items/uzi.png";
import vitaminTablets from "../../../assets/items/vitamin_tablets_CLEAN.png";
import woodenShield from "../../../assets/items/wooden_shield.png";

const itemSections = [
  {
    key: "weaponry",
    title: "WEAPONRY",
    text: "Physical attack items used in Murder Mystery Magic encounters.",
    items: [
      { name: "Stick", image: stick, description: "Basic weapon for early encounters." },
      { name: "Dagger", image: dagger, description: "Small blade for single-target threat." },
      { name: "Crowbar", image: crowbar, description: "An iron weapon with brutal impact." },
      { name: "Sword", image: sword, description: "Full size katana for high-tier melee." },
      { name: "Uzi", image: uzi, description: "Compact automatic burst pressure." },
      { name: "Revolver", image: revolver, description: "Classic single-shot presence." },
      { name: "Sawn Off", image: sawnOff, description: "Shortened double-barrel shotgun." },
      { name: "Desert Eagle", image: desertEagle, description: "Offers premium stopping power." },
      { name: "C8 Carbine", image: c8Carbine, description: "Serious offensive escalation." },
      { name: "Dirty Bomb", image: dirtyBomb, description: "Destruction at its dirtiest." },
    ],
  },
  {
    key: "protection",
    title: "PROTECTION",
    text: "Defensive items used to resist physical damage, and survive attacks.",
    items: [
      { name: "Vitamin Tablets", image: vitaminTablets, description: "Protection item with minimal effects." },
      { name: "Wooden Shield", image: woodenShield, description: "Offers basic physical protection." },
      { name: "Titanium Shield", image: titaniumShield, description: "Stronger built for heavier defense." },
      { name: "LV1 Armour", image: lv1Armour, description: "The original chest plate.", forceReverse: true },
      { name: "LV2 Armour", image: lv2Armour, description: "Added shoulder protection.", forceReverse: true },
      { name: "LV3 Armour", image: lv3Armour, description: "Added groin protection.", forceReverse: true },
      { name: "LV4 Armour", image: lv4Armour, description: "Added thigh protection.", forceReverse: true },
      { name: "LV5 Armour", image: lv5Armour, description: "Complete full body suit.", forceReverse: true },
      { name: "Body Guard", image: bodyGuard, description: "Stands between students and danger." },
      { name: "Holy Water", image: holyWater, description: "Sacred vial for supernatural protection." },
    ],
  },
  {
    key: "hardware",
    title: "HARDWARE",
    text: "Technology items used for their digital capabilities, such as hacking.",
    items: [
      { name: "Chromebook", image: chromebook, description: "Lightweight entry device for basic learning and access." },
      { name: "Samsung Laptop", image: samsungLaptop, description: "Dependable laptop for broader productivity and study." },
      { name: "ASUS VivoBook", image: asusVivobook, description: "Stronger portable laptop for creative and technical progress." },
      { name: "Librem Mini", image: libremMini, description: "Compact privacy-focused mini device with dedicated display." },
      { name: "Rasberry Pi", image: rasberryPi, description: "Small lab device with TFT screen and Wi-Fi antenna for experiments." },
      { name: "Flipper Zero", image: flipperZero, description: "Handheld tool for learning signals and device interaction." },
      { name: "AMD Desktop", image: amdDesktop, description: "Red-lit desktop setup built for heavier computing power." },
      { name: "Alienware", image: alienware, description: "Premium gaming laptop with blue neon performance styling." },
      { name: "Secure Workstation", image: secureWorkstation, description: "Hardened desktop station with deep purple security-class presence." },
      { name: "Offgrid Laboratory", image: offgridLaboratory, description: "Green-lit independent lab setup with antenna and satellite capability." },
    ],
  },
  {
    key: "gadget",
    title: "GADGET",
    text: "Special utility items with unusual tactical support functions.",
    items: [
      { name: "Crystal Ball", image: crystalBall, description: "Magical vision item used for mystical insights." },
      { name: "Goggles", image: goggles, description: "Hightech googles for seeing what cannot be seen." },
      { name: "Drone", image: drone, description: "Quadcopter for aerial scouting and observation." },
      { name: "Reloader", image: reloader, description: "Bundled ammunition restoring weapon readiness." },
      { name: "Cloak", image: cloak, description: "Dark invisibility cloak for stealth concealment." },
    ],
  },
  {
    key: "ultimate",
    title: "ULTIMATES",
    text: "Ultimate powers have their own dedicated page.",
    ultimateOnly: true,
  },
  {
    key: "xp",
    title: "XP",
    text: "Coins that increase a student's experience level.",
    items: [
      { name: "7500 XP", image: coin7500, description: "Bronze coin provides 7500 XP." },
      { name: "20000 XP", image: coin20000, description: "Silver coin provides 20000 XP." },
      { name: "50000 XP", image: coin50000, description: "Golden coin provides 50000 XP." },
    ],
  },
  {
    key: "horcrux",
    title: "HORCRUX",
    text: "A rare soul-bound survival artefact.",
    items: [
      { name: "Horcrux", image: horcrux, description: "Preserves a student beyond death." },
    ],
  },
  {
    key: "pass",
    title: "PASS",
    text: "VIP ticket that unlocks special privileges.",
    items: [
      { name: "Full Pass", image: fullPass, description: "The Pogforts full access pass is a N-word pass on steroids." },
    ],
  },
];

const ItemRow = ({ item, index }) => {
  const reverse = item.forceReverse || index % 2 === 1;

  return (
    <article className={`items-row ${reverse ? "items-row-reverse" : ""}`}>
      <div className="items-image-frame" aria-hidden="true">
        <img src={item.image} alt={`${item.name} item`} className="items-image" />
      </div>
      <div className="items-copy">
        <div className="items-name">{item.name}</div>
        <p>{item.description}</p>
      </div>
    </article>
  );
};

const Items = () => {
  const baseURL = window.location.origin;

  return (
    <div className="home-container items-page">
      <Helmet>
        <title>Pogforts - Items</title>
        <meta name="description" content="Details of all usable items at Pogforts." />
        <meta property="og:title" content="Items - Entire Inventory" />
        <meta property="og:description" content="Details of all usable items at Pogforts." />
        <meta property="og:image" content={`${baseURL}/assets/PogfortsHome.png`} />
        <meta property="og:url" content={`${baseURL}/items`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Items - Entire Inventory" />
        <meta name="twitter:description" content="Details of all usable items at Pogforts." />
        <meta name="twitter:image" content={`${baseURL}/assets/PogfortsHome.png`} />
      </Helmet>

      <h1 className="hidden-title">Items - Entire Inventory</h1>

      <img src={titleImage} alt="TitleItems" className="featured-image items-title-image" />

      <section className="items-shell profile-shell">
        <div className="items-panel profile-panel">
          <div className="items-topbar profile-topbar">
            <div>
              <div className="profile-kicker">POGFORTS INVENTORY</div>
              <h2 className="profile-title">Items Catalogue</h2>
              <div className="profile-subtitle">Public reference for the usable items inside Pogforts.</div>
            </div>
          </div>

          <div className="items-sections">
            {itemSections.map((section) => (
              <section key={section.key} className={`items-section items-section-${section.key}`}>
                <header className="items-section-header">
                  <div className="items-section-kicker">ITEM CATEGORY</div>
                  <h3 className="items-section-title">{section.title}</h3>
                  <p className="items-section-text">{section.text}</p>
                </header>

                {section.ultimateOnly ? (
                  <div className="items-ultimate-card">
                    <p>Click to view ultimates</p>
                    <a href="/ultimates" className="items-ultimate-button">
                      ULTIMATES
                    </a>
                  </div>
                ) : (
                  <div className="items-list">
                    {section.items.map((item, index) => (
                      <ItemRow key={`${section.key}-${item.name}`} item={item} index={index} />
                    ))}
                  </div>
                )}
              </section>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Items;
